import { Clinic } from './types';

export const mapResponseToAllClinics = (responseData: any): Array<Clinic> =>
  responseData.map((clinic) => ({
    id: clinic.id,
    name: clinic.name,
    address: clinic.address,
    waitwhileId: clinic.waitwhileId,
  }));
